import PropTypes from 'prop-types';
import {useState} from 'react';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Translation from '../../v2/lang/Translation';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';
import Button from '../Button/Button';
import useStyles from './CollapsiblePanel.styles';
import DropDownIcon from './DropDownIcon';

export function CollapsiblePanel(props) {
  const theme = useTheme();
  const [collapsed, setCollapsed] = useState(true);
  const classes = useStyles({...props, theme, collapsed});
  
  return (
    <>
      <div className={classes.header} data-test="CollapsiblePanel">
        <Button
          id={`${props.componentId}__dropDownButton`}
          className={classes.button}
          onClick={() => setCollapsed(!collapsed)}
          textOnly
        >
          <Translation>{props.label}</Translation>
          {props.iconEnabled && (
            <DropDownIcon className={classes.icon} />
          )}
        </Button>
      </div>
      
      <div className={classes.panel} data-test={`CollapsiblePanel__information${collapsed ? '' : '--extended'}`}>
        {props.children}
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

CollapsiblePanel.propTypes = {
  componentId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconEnabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(mapStateToProps)(CollapsiblePanel);
